import { useState } from "react";
import { Button, Group, Modal, Text } from "@mantine/core";
import { appShowNotification } from "@/utils/utils";

interface cancelSubscriptionProps {
  openedModal: boolean;
  setOpenedModal: (value: boolean) => void;
  handleCancelSubscription: () => Promise<void>;
}

const CancelSubscriptionDialog = ({
  setOpenedModal,
  openedModal,
  handleCancelSubscription,
}: cancelSubscriptionProps) => {
  const [loading, setLoading] = useState(false);

  const onCancelSubscription = async () => {
    setLoading(true);
    try {
      await handleCancelSubscription();
      appShowNotification({
        title: "Subscription cancelled successfully!",
        type: "success",
      });
    } catch (error) {
      appShowNotification({
        title: "Failed to cancel subscription!",
        type: "error",
      });
    }
    setOpenedModal(false);
    setLoading(false);
  };

  return (
    <Modal
      opened={openedModal}
      onClose={() => setOpenedModal(false)}
      title="Confirm Cancellation"
    >
      <Text>Are you sure you want to cancel your subscription?</Text>
      <Group mt="md">
        <Group mt="md">
          <Button loading={loading} onClick={() => setOpenedModal(false)}>
            No, Keep Subscription
          </Button>
          <Button loading={loading} color="red" onClick={onCancelSubscription}>
            Yes, Cancel Subscription
          </Button>
        </Group>
      </Group>
    </Modal>
  );
};

export default CancelSubscriptionDialog;
